import SessionManager from './session/SessionManager';

class MobileBridge {
  constructor() {
    this.listeners = {};
    this._motionObservers = [];
    this._speechDetectedObservers = [];
    this.initialized = false;
    this.token = null;

    this.register = this.register.bind(this);
    this.unregister = this.unregister.bind(this);
    this.fireNativeEvent = this.fireNativeEvent.bind(this);
    this.initialize = this.initialize.bind(this);
    this.login = this.login.bind(this);
    this.setToken = this.setToken.bind(this);
    this._navigateToComponent = this._navigateToComponent.bind(this);
    this._motionTilted = this._motionTilted.bind(this);
    this._speechDetected = this._speechDetected.bind(this);
    this.mobileLogout = this.mobileLogout.bind(this);
    this._setCompany = this._setCompany.bind(this);
  }

  get isMobile() {
    return window.cordova;
  }

  initialize(router) {
    if (!this.initialized) {
      this.router = router;
      this.register('logout', this.mobileLogout);
      // this.register("setCompany", this._setCompany)
      this.register('navigateToComponent', this._navigateToComponent);
      this.register('motionTilted', this._motionTilted);
      this.register('speechDetected', this._speechDetected);
      this.fireNativeEvent('hybrid.ready', { data: { token: this.token, lastNavigateTo: (localStorage.lastNavigateTo ? localStorage.lastNavigateTo : '') } });
      delete localStorage.lastNavigateTo;
      this.initialized = true;
    }
  }

  register(type, handler) {
    if (window.broadcaster != undefined) {
      this.listeners[type] = handler;
      window.broadcaster.addEventListener(type, handler);
    }
  }

  unregister(type) {
    if (window.broadcaster != undefined) {
      const handler = this.listeners[type];
      window.broadcaster.removeEventListener(type, handler);
    }
  }

  fireNativeEvent(type, data, callBack) {
    if (window.broadcaster != undefined) {
      window.broadcaster.fireNativeEvent(type, data, () => {
      });
    }
  }

  login(token, companyId) {
    this.token = token;
    this.fireNativeEvent('hybrid.login', { data: { token: token, company_id: companyId } });
  }

  setToken(token, force = false) {
    if (token != this.token || force) {
      this.token = token;
      this.fireNativeEvent('hybrid.set_token', { data: { token: localStorage.token } });
    }
  }
  
  mobileLogout() {
    SessionManager.logoff();
    this.fireNativeEvent('hybrid.logout', {});
    this.router.push({ pathname: '/login' });
  }

  /** THESE FUNCTIONS SHOULD ONLY BE CALLED BY CORDOVA/NATIVE */
  _setCompany(companyData) {
    const json = JSON.parse(companyData.data);
    this.fireNativeEvent('hybrid.debugInfo', {
      data: { info: 'Received set company from native' },
    });
    this.dataModel.companiesDAO.getCurrentCompany(parseInt(json.company_id, 10)).then(company => {
      if (company) {
        this.fireNativeEvent('hybrid.debugInfo', {
          data: { info: 'Fetched new Company' },
        });
      }
    });
  }

  _navigateToComponent(navigationJSON) {
    const json = JSON.parse(navigationJSON.data);

    let navPath = '/projects';

    if (json.component) {
      if (json.component == 'ProjectsTasks'){
        const requestedCompanyId = json.company_id;
        const requestedProjectId = json.project_id;
        const filter = json.filter;
        navPath = '/mobile/projects-tasks' + (requestedProjectId ? '/project/' + requestedProjectId : '') + (filter ? '/' + filter : '');
        // NOTE: props may not have been initialized with the latest data...
        if (requestedCompanyId != this.props.dataModel.stateTree.new_companies.currentCompany.id) {
          //if (requestedCompanyId != this.props.currentCompany.id) {
          this.props.dataModel.companiesDAO.getCurrentCompany(requestedCompanyId,).then(company => {
            if (company) {
              this.router.replace({ pathname: navPath, isRoot: false });
            }
          });
        } else {
          this.router.replace({ pathname: navPath, isRoot: false });
        }
      }
      else {
        let isRoot = true;
        switch (json.component) {
        case 'Root':
          navPath = '/mobilespinner';
          break;
        case 'Dashboard':
          navPath = '/dashboard';
          break;
        case 'Projects':
          navPath = '/mobile/projects';
          break;
        case 'Maps':
          navPath = '/mobile/maps';
          break;
        case 'Notifications':
          navPath = '/notifications';
          break;
        case 'MoreMenu':
          navPath = '/mobile/more';
          break;
        case 'SetPassword':
          navPath = '/set-password/' + json.data.invitationToken + '/' + json.data.email;
          break;
        case 'TaskDetails':
          navPath = '/mobile/projects-tasks/task/' + json.task_id;
          break;
        case 'ProjectDetails':
          navPath = '/mobile/projects/' + json.project_id;
          break;
        case 'Login':
          navPath = '/login';
          break;
        case 'Settings':
          navPath = '/mobile/settings';
          isRoot = false;
          break;
        case 'SwitchCompany':
          navPath = '/mobile/switch_company';
          isRoot = false;
          break;
        case 'MyProfile':
          navPath = '/mobile/my-profile';
          isRoot = false;
          break;
        default:
          break;
        }
        this.router.replace({ pathname: navPath, isRoot });
        if (json.deep_link) {
          let unlisten = this.router.listen((location) => {
            if (location.action == 'POP') {
              unlisten();
              this.gotoDeepLink(json.deep_link);
            }
          });
        }
      }
    } else if (json.deep_link) {
      this.gotoDeepLink(json.deep_link);
    }
  }

  gotoDeepLink(deepLink) {
    const deepLinkPath = this.getPathForDeepLink(deepLink);
    if (deepLinkPath) {
      console.log('deep link path = ' + deepLinkPath);
      this.router.push({ pathname: deepLinkPath, isRoot: false });
    }
  }
  
  getPathForDeepLink(deepLink) {
    if (deepLink) {
      console.log('checking deep link ' + deepLink);
      let match = deepLink.match(/^\/projects\/.*?\/build\/.*?\/task\/(.*)$/);
      if (match && match.length > 0) {
        return '/mobile/projects-tasks/task/' + match[1];
      }
      match = deepLink.match(/^\/tasks\/.*?\/task\/(.*)$/);
      if (match && match.length > 0) {
        return '/mobile/projects-tasks/task/' + match[1];
      }
      match = deepLink.match(/^\/projects\/(.*)$/);
      if (match && match.length > 0) {
        return '/mobile/projects/' + match[1];
      }
    }
    return deepLink;
  }

  addMotionObserver(observer) {
    if (this._motionObservers.indexOf(observer) == -1) {
      // ensure order from most recently registered to oldest
      this._motionObservers.unshift(observer);
    }
  }

  removeMotionObserver(observer) {
    let indexOfObserver = this._motionObservers.indexOf(observer);
    if (indexOfObserver != -1) {
      this._motionObservers.splice(indexOfObserver, 1);
    }
  }
  
  startMotionDetection() {
    this.fireNativeEvent('hybrid.startMotionDetection', { data: { } });
  }

  stopMotionDetection() {
    this.fireNativeEvent('hybrid.stopMotionDetection', { data: { } });
  }

  _motionTilted(event) {
    console.log(event.data);
    const motionData = JSON.parse(event.data);
    // copy the list of observers (should a handler remove itself and cause
    // us to miss notifying a valid observer)
    const motionObservers = this._motionObservers.slice();
    for (const observer of motionObservers) {
      const handled = observer(motionData);
      // if handler returns "true" then stop notifications
      if (handled) {
        break;
      }
    }
  }

  addSpeechDetectedObserver(observer) {
    if (this._speechDetectedObservers.indexOf(observer) == -1) {
      // ensure order from most recently registered to oldest
      this._speechDetectedObservers.unshift(observer);
    }
  }

  removeSpeechDetectedObserver(observer) {
    let indexOfObserver = this._speechDetectedObservers.indexOf(observer);
    if (indexOfObserver != -1) {
      this._speechDetectedObservers.splice(indexOfObserver, 1);
    }
  }
  
  /**
   * Triggers native speech detection
   *
   * @param {object} options The detection options supported are:
   *     beforeTimeout {number} - silence allowed before timing out (seconds, default is 5)
   *     afterTimeout {number} - silence after at least one utterance before timeout (seconds, default is 1)
   */ 
  detectSpeech(options) {
    if (!options) {
      options = {
        afterTimeout: 1,
      };
    }
    this.fireNativeEvent('hybrid.detectSpeech', { data: options });
  }

  _speechDetected(event) {
    console.log(event.data);
    const speechData = JSON.parse(event.data);
    // copy the list of observers (should a handler remove itself and cause
    // us to miss notifying a valid observer)
    const speechDetectedObservers = this._speechDetectedObservers.slice();
    for (const observer of speechDetectedObservers) {
      const handled = observer(speechData.text);
      // if handler returns "true" then stop notifications
      if (handled) {
        break;
      }
    }
  }

}

export default new MobileBridge();



// WEBPACK FOOTER //
// ./src/helpers/MobileBridge.js